import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useLocation } from 'react-router-dom';
import { useStore } from '@/models';
import cx from 'classnames';
import cs from './index.module.scss';
import Menu from './menu';
import Profile from './profile';
import Logo from './logo';
import Setting from './setting';
import Notice from './notice';
import Order from './order';
import Assets from './assets';
import Sign from './sign';

interface Props {
  transparent?: boolean;
}

const Header: React.FC<Props> = ({ transparent }) => {
  const location = useLocation();
  const [isVipHeaderScrolled, setIsVipHeaderScrolled] = useState(false);
  
  // 判断是否在合约或现货页面
  const isTradingPage = /^(\/futures\/contract\/)/.test(location.pathname) || /^(\/spot\/trade\/)/.test(location.pathname);
  const isVipPage = /^\/vip/.test(location.pathname);

  useEffect(() => {
    if (!isVipPage) {
      setIsVipHeaderScrolled(false);
      return;
    }

    const handleScroll = () => {
      setIsVipHeaderScrolled(window.scrollY > 24);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isVipPage]);

  return (
    <>
      <header
        className={cx(
          cs.header,
          transparent ? cs.transparent : '',
          isTradingPage ? cs.whiteBg : cs.grayBg,
          isVipPage ? 'vip-page-header' : '',
          isVipHeaderScrolled ? 'vip-page-header-scrolled' : '',
        )}
      >
        <div className={cs.headerGroup}>
          <Logo />
          <Menu />
        </div>

        <div className={cs.headerGroup}>
          {/* <Order /> */}
          {/* <Assets /> */}
          <Sign />
          <Setting />
          <Profile />

          {/* <div className={cx(cs.divider, transparent ? cs.transparent : '')} /> */}

          {/* <div className={cx(cs.divider, transparent ? cs.transparent : '')} /> */}
        </div>
      </header>

      <Notice />
    </>
  );
};

export default observer(Header);
